import type { InvoiceLine } from '../../../../graphql/generated/graphql';
import type { LineNumericBuffer } from '../hooks/use-numeric-inputs';
import { updateLineField } from './update-line-field';

/** The line as it would be committed if every buffered numeric text were blurred now.
 * Returns `line` itself when nothing is buffered. */
export function withNumericBuffer(
  line: Partial<InvoiceLine>,
  buffer: LineNumericBuffer | undefined
): Partial<InvoiceLine> {
  if (!buffer) return line;
  let effective = line;
  for (const [field, raw] of Object.entries(buffer)) {
    if (raw !== undefined) effective = updateLineField(effective, field as keyof InvoiceLine, raw);
  }
  return effective;
}
